/** Beneficial Owner Notices 문서 컴포넌트가 패널 공유 상태에 접근하는 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { BoNoticeFieldType } from './boNoticeFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface BoNoticeDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => BoNoticeFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;

  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;

  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;
}

export const BO_NOTICE_DOC_CTX: InjectionKey<BoNoticeDocContext> = Symbol('boNoticeDocCtx');
